import { AccessLevel, AccessLevels } from "../../../pojo/Fls";
import { RoleRights } from "./role.rights";
import { OrgRoleRightOverridePayload } from "./role.rights.config.service";

/** Effective Connect25 role rights on one organization: the org override when present, otherwise the global default. */
export namespace OrgRoleRights {
    export function globalLevel(
        baselineRights: RoleRights.RightWithRolesConfig[],
        rightName: string,
        roleId: number,
    ): AccessLevel {
        const definition = baselineRights.find((right) => right.rightName === rightName);
        if (!definition) return AccessLevels.None;
        return definition.roles.find((role) => role.roleId === roleId)?.accessLevel ?? AccessLevels.None;
    }

    export function findOverride(
        overrides: OrgRoleRightOverridePayload[],
        orgId: number | null | undefined,
        rightName: string,
        roleId: number,
    ): OrgRoleRightOverridePayload | undefined {
        if (orgId == null) return undefined;
        return overrides.find(
            (override) =>
                override.orgId === orgId && override.contRoleId === roleId && override.rightName === rightName,
        );
    }

    export function effectiveLevel(
        baselineRights: RoleRights.RightWithRolesConfig[],
        overrides: OrgRoleRightOverridePayload[],
        orgId: number | null | undefined,
        rightName: string,
        roleId: number,
    ): AccessLevel {
        const override = findOverride(overrides, orgId, rightName, roleId);
        if (override) return override.accessLevel;
        return globalLevel(baselineRights, rightName, roleId);
    }
}
